// extracted by mini-css-extract-plugin
export default {"container":"style_container__3oIzH","textContainer":"style_textContainer__vzwb4","boldText":"style_boldText__N02Nr"};